import React, { useEffect, useState } from 'react';
import PageLayout from 'components/layouts/PageLayout';
import NewButton from 'components/input/NewButton';
import ServiceHelper from 'stores/ServiceHelper';
import { AdminOptionDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import NewOptionModal from 'components/pages/options/NewOptionModal';
import OptionCard from 'components/pages/options/OptionCard';

const OptionGoodsSettingPage = () => {
  const { uiStore } = useStoreWrapper();

  const [options, setOptions] = useState<AdminOptionDto[]>([]);

  const handleAddOption = (option?: AdminOptionDto) => {
    uiStore?.modal.show({
      title: '옵션상품 추가',
      style: { width: 1200, height: '100%', maxHeight: '90vh' },
      children: <NewOptionModal option={option} />,
      onConfirmed: () => {
        ServiceHelper?.adminOptionService?.getOptions().then((res) => {
          setOptions(res.data);
        });
      },
    });
  };

  const handleClickOption = (option: AdminOptionDto) => {
    handleAddOption(option);
  };

  useEffect(() => {
    ServiceHelper?.adminOptionService?.getOptions().then((res) => {
      setOptions(res.data);
    });
  }, []);

  return (
    <PageLayout
      title="옵션상품 설정"
      actionButton={<NewButton onClick={handleAddOption}>상품추가</NewButton>}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
        }}
      >
        {options.map((option) => (
          <div style={{}} key={option.id}>
            <OptionCard
              option={option}
              onClick={() => {
                handleClickOption(option);
              }}
            />
          </div>
        ))}
      </div>
    </PageLayout>
  );
};

export default OptionGoodsSettingPage;
